<template>
  <div class="works container">
    <works ref="detailWorks" />
  </div>
</template>

<script>
import works from "../works.vue";
export default {
  components: {
    works,
  },
  activated() {
    this.$refs.detailWorks.getList();
  },
};
</script>

<style lang="less" scoped>
.works {
  padding: 10px 0;
  height: 100%;
}
</style>